import React, { useState, useRef, useEffect } from "react";
import { useTitle } from "../TitleContext";
import useAuth from "../../hooks/useAuth";
import Icon from "../ui/Icon";

const MenuHorizontal: React.FC = () => {
  const { title, subtitle } = useTitle();
  const auth = useAuth();
  const userName: string = auth.login;

  const getInitials = (fullName: string): string => {
    const names = fullName.split(" ");
    if (names.length > 1) {
      return names
        .map((name) => name[0])
        .join("")
        .toUpperCase();
    } else {
      return fullName.substring(0, 3).toUpperCase();
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setDropdownOpen((open) => !open);

  // Close on outside click or Escape key
  useEffect(() => {
    if (!dropdownOpen) return;

    function handleClick(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    function handleEsc(event: KeyboardEvent) {
      if (event.key === "Escape") setDropdownOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [dropdownOpen]);

  return (
    <header className="flex flex-row items-center justify-between py-6 px-4 h-16 border-b-2 bg-industrialBlack gap-x-4">
      <div className="flex flew-row items-center">
        <img className="w-64" src="/assets/forterro.png" alt="Company Logo" />
      </div>
      <ol className="xs:hidden relative isolate w-full h-[52px]  rounded-md p-1 flex flex-row items-center my-4 text-white font-display font-bold">
        <div className="flex flex-row items-center gap-x-4 flex-[0.7] px-4">
          {/* Display the dynamic title */}
          <li className="flex gap-1 items-center ">
            <h1>SYLOB TRANSLATION</h1>
          </li>
          {title && <Icon icon="superieur"></Icon>}
          {title && <h2>{title}</h2>}
          {subtitle && <Icon icon="superieur"></Icon>}
          {subtitle && <h2>{subtitle}</h2>}
        </div>
      </ol>

      <div className="relative text-black" ref={dropdownRef}>
        <button
          className="flex items-center"
          onClick={toggleDropdown}
          aria-haspopup="true"
          aria-expanded={dropdownOpen}
          aria-controls="user-menu"
          aria-label={`Open user menu for ${userName}`}
          type="button"
        >
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 text-white font-display text-base">
            {getInitials(userName)}
          </div>
        </button>
        {dropdownOpen && (
          <div
            id="user-menu"
            className="absolute right-0 bg-white text-black shadow-md rounded-lg z-[100]"
            role="menu"
            aria-labelledby="user-menu-button"
          >
            {/* LATER : add this to separate logout action from other actions <hr/> */}
            <button
              type="button"
              className="m-2 px-4 py-2 rounded font-display font-semibold focus:outline-none"
              onClick={() => {
                auth.logOutAction(false);
                setDropdownOpen(false);
              }}
              role="menuitem"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default MenuHorizontal;
